export { default as useAPIFetchApplicationDescription } from './description.hook';
export * from './description.types';
export { mockedDescriptionData } from './mock-data';
